import React, { useContext, useEffect } from "react";

import WidgetButtonsWrapper from "./WidgetButtonsWrapper";
import WidgetButton from "./WidgetButton";

import imgThumbnail6 from "styles/common/img/common/imgIcon1.png";
import imgThumbnail7 from "styles/common/img/common/imgIcon2.png";

import { closeApp } from "bridge/common/CommonBridge";

import { HandlerContext } from "../../../../../lnb/LnbWrapper";

function WidgetButtons({ toggleList, platformType }) {
    const handlerContext = useContext(HandlerContext);

    // 편집 버튼 클릭시
    const handleClickEditButton = () => {
        toggleList();
    };
    // 서비스 나가기 버튼 클릭시
    const handleClickExitButton = () => {
        handlerContext.clickExitAppButton();
    };

    const buttonList = [
        {
            thumbnailImage: imgThumbnail6,
            buttonClass: "btn1",
            titleText: "서비스 나가기",
            handleClick: handleClickExitButton,
            notDisplayPlatformType: ["Default"],
        },
        {
            thumbnailImage: imgThumbnail7,
            buttonClass: "btn2",
            titleText: "편집",
            handleClick: handleClickEditButton,
            notDisplayPlatformType: [],
        },
    ];

    useEffect(() => {
        // console.log("buttonList", buttonList);
        // console.log("platformType", platformType);
    }, [buttonList]);

    return (
        <WidgetButtonsWrapper>
            {buttonList.map((info, idx) => {
                return (
                    info.notDisplayPlatformType.indexOf(platformType) === -1 && (
                        <WidgetButton
                            key={idx}
                            buttonClass={info.buttonClass}
                            titleText={info.titleText}
                            thumbnailImage={info.thumbnailImage}
                            handleClick={info.handleClick}
                        />
                    )
                );
            })}
        </WidgetButtonsWrapper>
    );
}

export default WidgetButtons;
